import Joi from 'joi';

export const responseSchema = Joi.object({
  result: Joi.number().required(),
  error: Joi.any().when('result', {
    not: Joi.valid(0),
    then: Joi.string().required(),
    otherwise: Joi.forbidden(),
  }),
  payload: Joi.any().when('result', {
    is: Joi.valid(0),
    then: Joi.object({
      // eslint-disable-next-line camelcase
      access_token: Joi.string().required(),
    }),
  }),
});
